import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api/configTemplates";
import VaultSecret from "./VaultSecret.vue";
import FormCard from "@/components/Form/FormCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditSecretsForm',
    props: {
        template: null,
        title: null
    },
    emits: ["update"],
    setup(__props, { emit }) {
        async function update(secretName, secretValue) {
            emit("update", secretName, secretValue);
        }
        return { __sfc: true, emit, update, VaultSecret, FormCard };
    }
});
